import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import PublicHolidayContainer from './PublicHolidayContainer'


const PublicHolidayRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><PublicHolidayContainer></PublicHolidayContainer></Provider>
}

PublicHolidayRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default PublicHolidayRoot
